<template>
    <div ref="messagesContainer" class="chat_message_section" @scroll.passive="handleScroll">
        <GroupMessage
                v-for="(group, index) in messages"
                :key="index"
                :mgs-list="group.msgList"
                :name="group.name"
                :time="group.time"
                :me="group.me"
                :last-read-id="currentThread.lastMessageRead ? currentThread.lastMessageRead.id : '-1'"
                :id="'group-message-' + index "
        />
        <GroupMessage v-if="waitGroupMessages.msgList && waitGroupMessages.msgList.length > 0"
                :mgs-list="waitGroupMessages.msgList"
                :name="waitGroupMessages.name"
                :time="waitGroupMessages.time"
                :me="waitGroupMessages.me">
                <div style="align-self: flex-end">{{ $t('sending') }}</div>
        </GroupMessage>
        <spinner class="chat_loading_more_message" :show="isLoadingMessage"></spinner>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import GroupMessage from './GroupMessage'
import Message from './Message'
import Spinner from './Spinner'
import { SET_IS_LOADING_MESSAGE } from '../constants/mutation-types'

export default {
  name: 'MessageSection',
  components: {
    GroupMessage,
    Message,
    Spinner
  },
  data: function () {
    return {
        scrollMessgase: false,
        windowHeight: window.innerHeight
    }
  },
  computed: {
    ...mapGetters({
      threads: 'threads',
      currentThread: 'currentThread',
      messages: 'sortedMessages',
      waitGroupMessages: 'waitGroupMessages',
      isLoadingMessage: 'isLoadingMessage',
      isOpenChat: 'isOpenChat',
      isFocusInput: 'isFocusInput',
      isLoadedInitData: 'isLoadedInitData',
    }),
    ...mapState({
      userInfo: 'userInfo'
    })
  },
  mounted () {
      this.$nextTick(() => {
          window.addEventListener('resize', this.onResize)
      })
  },
  beforeUnmount () {
      window.removeEventListener('resize', this.onResize)
  },
  methods: {
    scrollToEnd () {
      var content = this.$refs.messagesContainer
      content.scrollTop = content.scrollHeight
    },
    handleScroll (e) {
      const scrollPos = e.target.scrollTop
      if (scrollPos === 0 && (this.currentThread.messages.length > 5 || this.currentThread.messages.length === 0)) {
        this.scrollMessgase = true
        this.sendGetHistory()
      }
    },
    ...mapActions({
      sendGetHistory (dispatch) {
        const { currentThread } = this
        if (!currentThread.loadend) {
          this.$store.commit(SET_IS_LOADING_MESSAGE, true)
          let pagingStartTime
          if (currentThread.messages.length > 0) {
            const firstGroupMessage = currentThread.messages[0]
            const oldMessage = this.$store.state.messages[firstGroupMessage.ids[0]]
            pagingStartTime = "" + new Date(oldMessage.time).getTime()
          } else {
            pagingStartTime = "" + new Date().getTime()
          }
          dispatch('sendGetHistory', {
            roomId: currentThread.id,
            pagingStartTime: pagingStartTime,
            pagingSize: 50
          })
        }
      }
    }),
    onResize () {
        this.windowHeight = window.innerHeight
    }
  },
  watch: {
    'currentThread.waitLastMessage': function () {
      this.$nextTick(() => {
        const ul = this.$refs.messagesContainer
        ul.scrollTop = ul.scrollHeight
      })
    },
    'currentThread.lastMessageRead': function () {
      this.$nextTick(() => {
        const ul = this.$refs.messagesContainer
        ul.scrollTop = ul.scrollHeight
      })
    },
    'isOpenChat': function () {
      this.$nextTick(() => {
        const ul = this.$refs.messagesContainer
        ul.scrollTop = ul.scrollHeight
      })
    },
    'currentThread.id': function () {
        if (this.currentThread.messages.length === 0 && this.isOpenChat && this.isLoadedInitData) {
            this.sendGetHistory()
        }
    },
    'isLoadedInitData': function () {
      this.$nextTick(() => {
        const ul = this.$refs.messagesContainer
        if (ul) {
          ul.scrollTop = ul.scrollHeight
        }
      })
    },
    'currentThread.lastMessage': function () {
      this.$nextTick(() => {
        const ul = this.$refs.messagesContainer
        ul.scrollTop = ul.scrollHeight
      })
    },
    'messages.length': function (newVal, oldVal) {
        if (this.scrollMessgase) {
            this.scrollMessgase = false
            const id = newVal - oldVal
            if (id > 0) {
                this.$nextTick(() => {
                    const ul = this.$refs.messagesContainer
                    if (ul) {
                        const container = ul.querySelector("#group-message-" + id)
                        if (container) {
                            ul.scrollTop = container.offsetTop
                        }
                    }
                })
            }
        }
    },
    'windowHeight': function () {
        const ul = this.$refs.messagesContainer
        ul.scrollTop = ul.scrollHeight
    }
  }
}
</script>

<style lang="scss">
.chat_message_section {
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    margin-top: 4px;
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 1 1 auto;
    margin-bottom: 16px;
    .chat_loading_message {
        align-self: center;
    }
    .chat_loading_more_message {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
}
</style>
